import acaoImagemService from "@/service/acaoImagemService";
import { ref } from "vue";
import { usePagination } from "@/composables/usePagination";

export function useAcaoImagem() {
  const imagens = ref([]);
  const imagem = ref(null);
  const isLoading = ref(false);
  const isSaving = ref(false);
  const pagination = usePagination({
    initialPage: 0,
    pageSize: 6,
    baseIndex: 0,
  });

  const fetchImagensByAcao = async (
    page = pagination.currentPage.value,
    size = pagination.pageSize.value,
    acaoId
  ) => {
    if (!acaoId) {
      imagens.value = [];
      pagination.resetPagination();
      return;
    }
    isLoading.value = true;
    try {
      const data = await acaoImagemService.getAcaoImagensByAcaoId(
        acaoId,
        page,
        size
      );

      if (data && Array.isArray(data.content)) {
        imagens.value = data.content;
        pagination.setPaginationInfo(data);
      } else if (Array.isArray(data)) {
        pagination.setPaginationInfo(data);
        pagination.totalPages.value = Math.max(
          Math.ceil(data.length / size),
          1
        );
        pagination.currentPage.value = page;
        if (data.length > size) {
          imagens.value = data.slice(page * size, (page + 1) * size);
        } else {
          imagens.value = data;
        }
      } else {
        imagens.value = [];
        pagination.resetPagination();
      }
      return data;
    } catch (error) {
      console.error("Erro ao buscar imagens da ação:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  const saveImagem = async (acaoId, imagemData) => {
    isSaving.value = true;
    try {
      const data = await acaoImagemService.postAcaoImagem(acaoId, imagemData);
      return data;
    } catch (error) {
      console.error("Erro ao salvar imagem da ação:", error);
      throw error;
    } finally {
      isSaving.value = false;
    }
  };

  const saveLoteImagens = async (acaoId, imagensData) => {
    isSaving.value = true;
    try {
      const data = await acaoImagemService.postLoteAcaoImagem(
        acaoId,
        imagensData
      );
      return data;
    } catch (error) {
      console.error("Erro ao salvar lote de imagens da ação:", error);
      throw error;
    } finally {
      isSaving.value = false;
    }
  };

  const deleteImagem = async (acaoImagemId) => {
    isLoading.value = true;
    try {
      const data = await acaoImagemService.deleteAcaoImagem(acaoImagemId);
      return data;
    } catch (error) {
      console.error("Erro ao deletar imagem da ação:", error);
      throw error;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    imagens,
    imagem,
    isLoading,
    isSaving,
    pagination,
    fetchImagensByAcao,
    saveImagem,
    saveLoteImagens,
    deleteImagem,
  };
}
